module.exports = __webpack_public_path__ + "img/assessment-gray.svg";